<app-combined-orders [stores]="stores"></app-combined-orders>
